export const isInternalSupportEmployee = employee =>
    [true, 1, '1', 'true'].includes(employee?.emp_is_internal_support);

export const excludeInternalSupportEmployees = employees =>
    (employees || []).filter(employee => !isInternalSupportEmployee(employee));
